import { InfolinePopoverButton } from "@silvertours/front-entities";
import { Header as HeaderComponent } from "./Header";
import { Navigation, LoginButton, LoggedInActions } from "./components";
import { Separator } from "./Header.styles";
var Header = HeaderComponent;
Header.Navigation = Navigation;
Header.Separator = Separator;
Header.InfolinePopoverButton = InfolinePopoverButton;
Header.LoginButton = LoginButton;
Header.LoggedInActions = LoggedInActions;
export { Header };
